import { Button } from 'antd'
import { FC, useContext, useState } from 'react'
import styled from 'styled-components'
import { getTheme } from 'packages/theme'
import { AnyType } from 'packages/types'
import { LoginDialog } from './Dialog'
import { ActivityLoginContext } from './context'
import { validUrlParams } from './utils'

type HeaderProps = {
  logo: string
  name: string
  themeColor: string
  isPreview?: boolean
  hasInviteCode?: boolean
  onClosePreview?: () => void
}

/**
 * 头部
 *
 * @param param0 - 参数
 * @param param0.logo - logo
 * @param param0.name - 活动名称
 * @param param0.isPreview - 是否预览
 * @param param0.themeColor - 主题色
 * @param param0.onClosePreview - 关闭预览回调
 * @param param0.hasInviteCode - 是否需要邀请码
 * @returns  头部
 */
export const Header: FC<HeaderProps> = ({
  logo,
  name,
  isPreview,
  themeColor,
  hasInviteCode,
}) => {
  const theme = getTheme(themeColor)
  const { schoolId } = useContext(ActivityLoginContext)

  const [visible, setVisible] = useState(false)
  return (
    <header
      style={{
        boxShadow:
          '0px 0px 1px 0px rgba(21, 29, 41, 0.2),0px 3px 8px -1px rgba(21, 29, 41, 0.04)',
      }}
    >
      <Content>
        {logo ? (
          <img
            src={logo}
            height={40}
          />
        ) : (
          <div />
        )}
        <HeaderRight $tmpTheme={theme}>
          <Button
            onClick={async () => {
              if (isPreview) {
                setVisible(true)
              } else {
                const validUrl = await validUrlParams()
                if (!validUrl) return
                setVisible(true)
              }
            }}
            type="primary"
            size="large"
            style={{
              backgroundColor: theme?.brand._1,
              borderColor: theme?.brand._1,
              marginRight: 0,
            }}
          >
            {'登录/注册'}
          </Button>
        </HeaderRight>
        <LoginDialog
          visible={visible}
          onChangeVisible={(v) => setVisible(v)}
          name={name}
          hasInviteCode={hasInviteCode}
          schoolId={schoolId}
          brandColor={theme.brand._1}
          isPreview={isPreview}
        />
      </Content>
    </header>
  )
}

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 72px;
  padding: 0 20px;
`

const HeaderRight = styled.div<{ $tmpTheme?: AnyType }>`
  display: flex;
  gap: 56px;
  align-items: center;
  &&& {
    .ant-btn-primary[disabled] {
      background-color: ${(p) => p.$tmpTheme?.brand._4};
      border: 1px solid ${(p) => p.$tmpTheme?.brand._4};
    }
  }
`
